import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Select } from 'redpoints-front-components/index';
import { withContext } from 'redpoints-front-common/components';

import {
  facilitatorValidationFetchDomains,
  facilitatorValidationSetSelectedDomainId,
} from '../../../actions/facilitatorValidationActions';
import {
  getFacilitatorValidationDomains,
  getFacilitatorValidationDomainsIsLoading,
  getFacilitatorValidationSelectedDomainId,
  getFacilitatorValidationSelectedFilterByCustomer,
} from '../../../reducers/tasks/facilitatorValidation';
import { translate } from '../../../helpers/languageHelper';

const getTranslation = key =>
  translate(`tasks.facilitatorValidation.filters.domains.${key}`);

const FacilitatorValidationFiltersDomain = ({
  customer: { customerId },
  domains,
  facilitatorValidationSetSelectedDomainId,
  facilitatorValidationFetchDomains,
  isLoading,
  selectedDomainId,
  filterByCustomer,
}) => {
  const customerIdToFetch = filterByCustomer ? customerId : undefined;

  useEffect(() => {
    facilitatorValidationFetchDomains({
      customerId: customerIdToFetch,
    });
  }, [customerIdToFetch, facilitatorValidationFetchDomains]);

  const handleDomainChange = domainId =>
    facilitatorValidationSetSelectedDomainId({ domainId });

  return (
    <Select
      allowClear
      data={domains}
      disabled={isLoading}
      placeholder={getTranslation('placeholder')}
      label={getTranslation('label')}
      loading={isLoading}
      onChange={handleDomainChange}
      showSearch
      value={selectedDomainId ?? undefined}
    />
  );
};

const mapStateToProps = state => ({
  domains: getFacilitatorValidationDomains(state),
  filterByCustomer: getFacilitatorValidationSelectedFilterByCustomer(state),
  isLoading: getFacilitatorValidationDomainsIsLoading(state),
  selectedDomainId: getFacilitatorValidationSelectedDomainId(state),
});

export default compose(
  withContext,
  connect(mapStateToProps, {
    facilitatorValidationSetSelectedDomainId,
    facilitatorValidationFetchDomains,
  })
)(FacilitatorValidationFiltersDomain);
